import qs from 'qs';
import {
  UPDATE_LOADING_STATUS,
  GET_PLANNING_DATA,
  SET_SELECTED_CATEGORY_INDEX,
  SET_SLIDE_ARRAY,
  RESET_SELECTED_SLIDE,
  RESET_READY_ADD_TO_CART_LIST,
  UPDATE_SAME_POSITION,
  UPDATE_GOTO_ROW,
  UPDATE_IS_SEND_DESIGN_CODE,
  UPDATE_SHOW_RESULT_STATUS,
  UPDATE_SHOW_GET_PRODUCTION_JSON_MODAL,
  UPDATE_SHOW_PRODUCTION_LIST_MODAL,
  UPDATE_SHOW_POST_PRODUCTION_JSON_MODAL,
  UPDATE_SHOW_ADD_TO_CART_PRODUCT_LIST_MODAL,
  UPDATE_LIST_DATA_JSON,
  UPDATE_SIMPLE_PRODUCT_DATA,
  UPDATE_TOTAL_AMOUNT,
  UPDATE_READY_ADD_TO_CART_LIST,
  UPDATE_READY_ADD_TO_CAR_LIST,
  UPDATE_ALREADY_ADD_TO_CART_LIST,
  POST_SAVE_STATUS_API,
  GET_SAVE_STATUS_API,
} from "../constants/actionsTypes";

import { getSimpleProductionUrl, computeAmount } from "../utility/global";

import { apiPostSimpleProduct, apiPostAddToCart } from "./testJsonApi";

const PlanningData = require("../data/productData.json");

export const updateLoadingStatus = (isLoading) => ({
  type: UPDATE_LOADING_STATUS,
  isLoading,
});

export const getPlanningData = () => ({
  type: GET_PLANNING_DATA,
  planningData: PlanningData[0],
});

export const setSelectedCategoryIndex = (selectedCategoryIndex) => ({
  type: SET_SELECTED_CATEGORY_INDEX,
  selectedCategoryIndex,
});

export const setSlideArray = (selectedState) => ({
  type: SET_SLIDE_ARRAY,
  selectedState,
});

export const resetSelectedSlide = (isReset) => ({
  type: RESET_SELECTED_SLIDE,
  isReset,
});

export const updateSamePosition = (isGoToTheSamePosition) => ({
  type: UPDATE_SAME_POSITION,
  isGoToTheSamePosition,
});

export const updateGoToRow = (gotoRow) => ({
  type: UPDATE_GOTO_ROW,
  gotoRow,
});

export const updateIsSendDesignCode = (isSendDesignCode) => ({
  type: UPDATE_IS_SEND_DESIGN_CODE,
  isSendDesignCode,
});

export const updateShowResultStatus = (isShowResult) => ({
  type: UPDATE_SHOW_RESULT_STATUS,
  isShowResult,
});

export const updateShowGetProductionJsonModal = (
  isShowGetProductionJsonModal
) => ({
  type: UPDATE_SHOW_GET_PRODUCTION_JSON_MODAL,
  isShowGetProductionJsonModal,
});

export const updateShowProductionListModal = (isShowProductionListModal) => ({
  type: UPDATE_SHOW_PRODUCTION_LIST_MODAL,
  isShowProductionListModal,
});

export const updateShowPostProductionJsonModal = (
  isShowPostProductionJsonModal
) => ({
  type: UPDATE_SHOW_POST_PRODUCTION_JSON_MODAL,
  isShowPostProductionJsonModal,
});

export const resetReadyAddToCartList = () => ({
  type: RESET_READY_ADD_TO_CART_LIST,
});

export const updateShowAddToCartProductListModal = (
  isShowAddToCartProductListModal
) => ({
  type: UPDATE_SHOW_ADD_TO_CART_PRODUCT_LIST_MODAL,
  isShowAddToCartProductListModal,
});

export const updateReadyAddToCarList = (readyAddToCartList) => ({
  type: UPDATE_READY_ADD_TO_CAR_LIST,
  readyAddToCartList,
});

export const updateReadyAddToCartList = (sku) => ({
  type: UPDATE_READY_ADD_TO_CART_LIST,
  sku,
});

export const updateAlreadyAddToCartList = (alreadyAddToCartProduct) => ({
  type: UPDATE_ALREADY_ADD_TO_CART_LIST,
  alreadyAddToCartProduct,
});

export const updateListDataJson = (listData) => ({
  type: UPDATE_LIST_DATA_JSON,
  listData,
  readyAddToCartList: listData,
});

export const updateSimpleProductData = (simpleProductData) => ({
  type: UPDATE_SIMPLE_PRODUCT_DATA,
  simpleProductData,
});

export const updateTotalAmount = (totalAmount) => ({
  type: UPDATE_TOTAL_AMOUNT,
  totalAmount,
});

// 以下為 api 相關
export const postSaveStatusApi = (selectedCategoryIndex, selectedState) => ({
  type: POST_SAVE_STATUS_API,
  selectedCategoryIndex,
  selectedState,
});

export const getSaveStatusApi = (savedCode) => ({
  type: GET_SAVE_STATUS_API,
  savedCode,
});

// thunks
export const postSimpleProductApi = (selectedProduction) => {
  return (dispatch, getState) => {
    if (selectedProduction.length === 0) return;

    let simpleProdUrl = getSimpleProductionUrl(selectedProduction);

    return apiPostSimpleProduct(simpleProdUrl)
      .then((res) => {
        const simpleProductData = res.data.data;
        dispatch(updateSimpleProductData(simpleProductData));

        let totalAmount = computeAmount(simpleProductData, selectedProduction);
        dispatch(updateTotalAmount(totalAmount));
      })
      .catch((err) => {
        console.log(err);
      });
  };
};

export const postAddToCartApi = (productList) => {
  return (dispatch, getState) => {
    let addToCartProduct = JSON.parse(JSON.stringify(productList));
    if (addToCartProduct.sku !== "0") {
      const { sku, qty } = addToCartProduct;
      let request = {
        'productCodePost': sku,
        'qty': qty,
        'catePath': window.SEOCatePath,
        'CSRFToken': window.CSRFToken
      }
      
      return apiPostAddToCart(qs.stringify(request))
        .then((res) => {
          let data = JSON.parse(res.data);
          if (data.rtnMsg === "Success") {
            dispatch(updateAlreadyAddToCartList(addToCartProduct));
            dispatch(updateReadyAddToCartList(sku));
          } else {
            alert(data.rtnMsg);
            updateShowAddToCartProductListModal(false);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      dispatch(updateAlreadyAddToCartList(addToCartProduct));
      dispatch(updateReadyAddToCartList(addToCartProduct.sku));
    }
  };
};
